import { render } from "./BaseTask.vue?vue&type=template&id=166b6cca&scoped=true"
import script from "./BaseTask.vue?vue&type=script&lang=js"
export * from "./BaseTask.vue?vue&type=script&lang=js"

import "./BaseTask.vue?vue&type=style&index=0&id=166b6cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166b6cca"]])

export default __exports__